import Cookie from "js-cookie";
import SDK from "@datarangers/sdk-javascript";
import { NyhAd } from '@/utils/appInteraction'

// 身份
const identityText = {
  1: '医务工作者',
  2: '在校医学生',
  3: '患者及其家属',
  4: '企业人士',
  5: '科研人员',
  6: '海外人士',
  7: '患者端用户',
  8: '参会者'
}
let debugMode = 'dev';
// 判断环境
if (/www\.|link\./.test(window.location.hostname)) {
  debugMode = 'pro';
} else {
  debugMode = 'dev';
}
const app_ids = {
  pro: 20009567,
  dev: 20009577
}

const AnalysysAgent = {
  init(options) {
    SDK.init({
      app_id: options.app_id,
      channel_domain: options.channel_domain,
      log: debugMode === 'dev',
      enable_debug: debugMode === 'dev',
      autotrack: true, // 全埋点模块
      enable_stay_duration: true, // 页面停留时长
    });
    SDK.start();
  },
  alias(userId) {
    SDK.config({ user_unique_id: userId });
    const analysysUnionid = Cookie.get("xuanwu_member_unionid") || localStorage.getItem("xuanwu_member_unionid") || '';
    const AnalysysAgent_identity = Cookie.get("medtion_member_identity") || '';
    SDK.event('profileSet', {
      xwho: userId,
      unionid: analysysUnionid,
      identity: identityText[Number(AnalysysAgent_identity)]
    })
  },
  track(eventName, eventInfo) {
    SDK.event(eventName, eventInfo);
  },
};

AnalysysAgent.init({
  app_id: app_ids[debugMode],
  channel_domain: 'https://gator.volces.com',
});
if (Cookie.get('medtion_member_id')) {
  AnalysysAgent.alias(Cookie.get('medtion_member_id'));
}

export function yg_video_view(type, videoId, courseid, videoName, talker, percent, video_parent_name) {
  let eventInfo = {
    "video_id": "" + videoId,
    "video_name": videoName,
    "video_type": '云课堂',
    "video_content": "课程",
    "duration": 0,
    "percent": 0,
    "courseid": courseid,
    "pubisher": talker,
    "video_parent_name": video_parent_name
  };
  if (type === 'init') {
    eventInfo['video_start_time'] = new Date().Format('yyyy-MM-dd hh:mm:ss');
    eventInfo['heartbeat'] = false;
  } else if ('setInterval') {
    eventInfo['duration'] = 60;
    eventInfo['heartbeat'] = true;
    eventInfo["percent"] = percent;
  }
  AnalysysAgent.track("view_video", eventInfo);
}

export function ad_exposure(item) {
  if(!item.id) return;
  let eventInfo = {
    'ad_id': item.id,
    'exposure_location': item.clickLocation,
    'unionid': Cookie.get('xuanwu_member_unionid') ? Cookie.get('xuanwu_member_unionid') : '',
    'ad_name': item.name,
    'ad_module': item.module,
    'ad_extras': item.extras,
    'ad_code': item.code,
    'ad_extras_id': '',
  }
  AnalysysAgent.track('ad_exposure', eventInfo)
}

export function ad_click(item) {
  var eventInfo = {
    ad_click_location: item.clickLocation,
    ad_module: item.module,
    ad_code: item.code,
    ad_name: item.name,
    ad_extras: item.extras + '',
    ad_id: item.adId + '',
    ad_url: new NyhAd(item).web_href,
    ad_module_compare: '',
    ad_extras_id: '',
    unionid: '',
  };
  AnalysysAgent.track("ad_click_new", eventInfo);
}

export function add_to_favorite(company = '', liker_company = '', position = '', liker_major = [], liker_positon = '', publish_type = '', liker = '', major = [], target_id = '', target_name = '', item_id = '', pubisher = '', type = '', item_name = '') {
  let eventInfo = {
    'company': company,
    'liker_company': liker_company,
    'position': position,
    'liker_major': liker_major,
    'liker_positon': liker_positon,
    'publish_type': publish_type,
    'liker': liker,
    'major': major,
    'target_id': target_id,
    'target_name': target_name,
    'item_id': item_id,
    'pubisher': pubisher,
    'type': type,
    'item_name': item_name
  }
  AnalysysAgent.track('add_to_favorite', eventInfo)
}

export function btn_click(btn_name = '', page_name = '') {
  let eventInfo = {
    'btn_name': btn_name,
    'page_name': page_name
  }
  AnalysysAgent.track('btn_click', eventInfo)
}

export function pageview(userid = '', unionid = '', title = '', url = '') {
  let eventInfo = {
    'userid': userid,
    'unionid': Cookie.get('xuanwu_member_unionid') ? Cookie.get('xuanwu_member_unionid') : '',
    '$title': title,
    '$url': url
  }
  AnalysysAgent.track('$pageview', eventInfo)
}

export function searchAnalys(has_result = true, result_count = 1, is_history = false, key_word = '', is_recommended = false, search_from = '') {
  let eventInfo = {
    'has_result': has_result,
    'result_count': result_count,
    'is_history': is_history,
    'key_word': key_word,
    'is_recommended': is_recommended,
    'search_from': search_from
  }
  AnalysysAgent.track('search', eventInfo)
}
